import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import CollectorErrorPage from 'modules/Collectors/ErrorPage/CollectorErrorPage';
import CollectorAccessDeniedPage from 'modules/Collectors/ErrorPage/CollectorAccessDeniedPage';
import CollectorInsufficientPermissionsPage from 'modules/Collectors/ErrorPage/CollectorInsufficientPermissionsPage';
import TIRouteProps from './TIRouteProps';

const CollectorErrorRoute: TIRouteProps = {
  path: '/collector/error',
  component: CollectorErrorPage,
  exact: true,
  title: <FormattedMessage id="collectors.collectorErrorTitle" />
};

const CollectorAccessDeniedRoute: TIRouteProps = {
  path: '/collector/access_denied',
  component: CollectorAccessDeniedPage,
  exact: true,
  title: <FormattedMessage id="collectors.collectorAccessDeniedTitle" />
};

const CollectorInsufficientPermissionsRoute: TIRouteProps = {
  path: '/collector/insufficient_permissions',
  component: CollectorInsufficientPermissionsPage,
  exact: true,
  title: (
    <FormattedMessage id="collectors.collectorInsufficientPermissionsTitle" />
  )
};

const collectorErrorRoutes: TIRouteProps[] = [
  CollectorErrorRoute,
  CollectorAccessDeniedRoute,
  CollectorInsufficientPermissionsRoute
];

export const CollectorErrorRoutes: React.FC = () => {
  return (
    <Switch>
      {collectorErrorRoutes.map((route: TIRouteProps) => (
        <Route
          key={Array.isArray(route.path) ? route.path[0] : route.path}
          {...route}
        />
      ))}
    </Switch>
  );
};

export const isCollectorErrorRoute = (pathname: string): boolean => {
  return collectorErrorRoutes.some((r) =>
    pathname.startsWith(Array.isArray(r.path) ? r.path[0] : r.path!)
  );
};
